import CreateCustomerContactModal from './CreateCustomerContactModal';

export default CreateCustomerContactModal;
